import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Image } from '@descope/page-editor-components';
import { EditorImageSettings } from './EditorImageSettings';
import placeholder from './placeholder.png';

type Props = Omit<React.ComponentProps<typeof Image>, 'width' | 'height'> & {
	width?: number;
	height?: number;
};

const EditorImage = ({ width, height, ...props }: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode((state) => ({
		hasSelectedNode: state.events.selected,
		hasDraggedNode: state.events.dragged
	}));

	const refCb = useCallback(
		(ref: HTMLImageElement) => connect(drag(ref)),
		[connect, drag]
	);

	return (
		<div ref={refCb}>
			<Image width={width} height={height} {...props} />
		</div>
	);
};

EditorImage.defaultProps = {
	width: undefined,
	height: undefined
};

EditorImage.craft = {
	name: 'Image',
	props: {
		src: placeholder,
		alt: 'Image',
		width: undefined,
		height: undefined
	},
	related: {
		settings: EditorImageSettings
	}
};

export { EditorImage };
